import * as React from 'react';
import Button from 'antd/lib/button';
import Drawer from 'antd/lib/drawer';
import Space from 'antd/lib/space';

const FIX_SETTINGS_DRAWER_WIDTH = 640;

interface FixSettingsDrawerProps {
    title: string;
    open: boolean;
    loading: boolean;
    onSave: () => void;
    onCancel: () => void;
    afterClose: () => void;
    children: React.ReactNode;
}

const FixSettingsDrawer: React.FC<FixSettingsDrawerProps> = (props: FixSettingsDrawerProps) => (
    <Drawer
        title={props.title}
        open={props.open}
        onClose={props.onCancel}
        afterOpenChange={(open) => !open && props.afterClose()}
        destroyOnClose
        width={FIX_SETTINGS_DRAWER_WIDTH}
        extra={
            <Space>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button type="primary" loading={props.loading} onClick={props.onSave}>
                    Save
                </Button>
            </Space>
        }
    >
        {props.children}
    </Drawer>
);

export default FixSettingsDrawer;
